import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { v_LocationDetailBus } from "./v_LocationDetailBus";

export class v_DispatchAttachmentBus extends BaseBus
{
    constructor(busObj: v_DispatchAttachmentBus = null) {
        super(busObj);
        if (busObj !== null) {
            this.addedDate = DateFunctions.getDate(this.addedDate);
            this.expenseDate = DateFunctions.getDate(this.expenseDate);
        }
    }
    CID(): any {
        return this.dispatchAttachmentId;
    }
    setId(id: any) {
        this.dispatchAttachmentId = id;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }
    initialize(data: v_DispatchAttachmentBus) {
        super.initialize(data);
        try {
            this.addedDate = CommonFunctions.getDate(data.addedDate);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
            this.expenseDate = CommonFunctions.getDate(data.expenseDate);
            this.sageDt = CommonFunctions.getDate(data.sageDt);
        }
        catch {

        }

    }
    setFromForm(data: v_DispatchAttachmentBus) {
        super.setFromForm(data);
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
            this.addedDate = date;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.addedDate = date;
        this.personId = personId;
    }

    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }

    set inFinance(val:boolean) { }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

        if (DateFunctions.isValidDate(this.addedDate)) {
            this.addedDate = DateFunctions.getDateWithUTCOffset(this.addedDate);
        }
        if (DateFunctions.isValidDate(this.expenseDate)) {
            this.expenseDate = DateFunctions.getDateWithUTCOffset(this.expenseDate);
        }
        if (DateFunctions.isValidDate(this.sageDt)) {
            this.sageDt = DateFunctions.getDateTimeWithUTCOffset(this.sageDt);
        }
    }
  dispatchAttachmentId: any;
  addedDate: Date;
  attachmentDesc: string;
  isReimbursement: boolean;
  reimbursementAmount: number;
  expenseDate: Date;
  attachmentType: string;
  isImage: boolean;
  isViewable: boolean;
  attachmentName: string;
  attachment: any;
  visibleToCustomer: boolean;
  personName: string;
  sageDt: Date;
  sentToPayroll: boolean;
  dispatchId: any;
  dispatchAttachmentDetailId: any;
  personId: any;
  reimbursementTypeId: any;
    billingCodeId: any;
    billingCode: string;
    reimbursementTypeName: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    mgrApproved: boolean;
    materialType: string;
    isRefrigerant: boolean;
}
